import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ArrayChipLogic from '@/components/UI/ArrayChips/ArrayChipLogic';
import { getCampaignInfo } from '@/redux/Campaign/campaign.reducer';
import { getHeaderLanguage } from '@/redux/Header/header.reducer';
import styles from '../VolumeDetails.module.scss';
import SummaryVehiclesCleanDirt from './SummaryVehiclesCleanDirt';
import LimitationTable from '../../../../../SubCampaignDetail/Vehicles/LimitationVolume/LimitationTable';

const Summary = (props) => {
  const { plantSelected, series, volumes, headerLanguage } = props;
  const { t } = useTranslation();
  const [affectVehiclesSummary, setAffectVehiclesSummary] = useState([]);

  useEffect(() => {
    const selectedModelSeries = series?.filter((currentSerie) => {
      const versionsValues = Object.values(currentSerie?.typeVersions);

      return versionsValues.some(
        (currentPlants) => currentPlants.some(({ wkzNumber }) => wkzNumber === plantSelected?.wkzNumber),
      );
    })
      .map((serie) => serie.serie);

    setAffectVehiclesSummary([...new Set(selectedModelSeries)]);
  }, [plantSelected]); // eslint-disable-line react-hooks/exhaustive-deps

  const volumeSelected = volumes.find((vol) => vol.plant === plantSelected.wkzNumber) || {};

  return (
    <>
      <div className={styles.TabContainer}>
        <strong> {t('affectedVehicles.SUMMARY')}</strong>
        <div className={styles.BoxContainer}>
          <span>
            {t('summary.affectedVehicles')}
          </span>
          <div className={styles.BoxContent}>
            <ArrayChipLogic
              detailTitle={t('summary.affectedVehicles')}
              chipData={affectVehiclesSummary}
            />
          </div>
        </div>
        <LimitationTable volume={volumeSelected?.limitationVolumeManualEntry} headerLanguage={headerLanguage} />
        <SummaryVehiclesCleanDirt plantWkz={plantSelected.wkzNumber} />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  headerLanguage: getHeaderLanguage(state) || getCampaignInfo(state)?.defaultLanguage,
});

export default connect(mapStateToProps)(Summary);
